import { Box, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../content/Content";
import '../liveCast.component.css'
const FavoriteSessions = () => {
  return (
      <div>
          <VStack
            w="100%"
            pb="40px"
            borderRadius="26px"
            bg={"rgba(255, 255, 255, 1)"}
            mx="30px"
            h="100%"
            className="desktop-version"
          >
            {/* Top Bar */}
            <Stack
              justifyContent={"flex-start"}
              alignItems={"center"}
              flexDir="row"
              w="100%"
              p={"15px 25px"}
              mt="40px"
              flexWrap="wrap"
              flexDirection={"column"}
            >
              <Image src={Img.favorite} width="13px" h="25px" />
              <Text
                fontFamily="ProximaNova"
                fontSize="20px"
                fontWeight="800"
                color="rgba(41, 45, 50, 1)"

              >
                Favorite Sessions
              </Text>
              <Box
                borderBottom="1px solid rgba(236, 236, 236, 1)"
                w="100%"
                py="10px"
              ></Box>
            </Stack>
            <Stack p={"15px 25px"} w="100%">
                  <Box bg="rgba(255, 255, 255, 1)" boxShadow= "0px 10px 10px 0px rgba(96, 31, 235, 0.06)" padding={'15px 24px'} w="100%" display="flex" justifyContent="flex-start" alignItems='center' borderRadius="15px">
                      <Image src={Img.play} w="21.67px" h="26px"/>
                      <Text           
                      fontFamily="ProximaNova"
                      fontSize="20px"
                      fontWeight="800"
                      color="rgba(149, 151, 171, 1)"
                      mx="10px"
                      >
                          FRX102- introductions ti trade  <br />
                          overview
                      </Text>
                  </Box>
                  <Box bg="rgba(255, 255, 255, 1)" boxShadow= "0px 10px 10px 0px rgba(96, 31, 235, 0.06)" padding={'15px 24px'} w="100%" display="flex" justifyContent="flex-start" alignItems='center' borderRadius="15px">
                      <Image src={Img.play} w="21.67px" h="26px"/>
                      <Text           
                      fontFamily="ProximaNova"
                      fontSize="20px"
                      fontWeight="800"
                      color="rgba(149, 151, 171, 1)"
                      mx="10px"
                      >
                          FRX102- introductions ti trade  <br />
                          overview
                      </Text>
                  </Box>
                  <Box bg="rgba(255, 255, 255, 1)" boxShadow= "0px 10px 10px 0px rgba(96, 31, 235, 0.06)" padding={'15px 24px'} w="100%" display="flex" justifyContent="flex-start" alignItems='center' borderRadius="15px">
                      <Image src={Img.play} w="21.67px" h="26px"/>
                      <Text           
                      fontFamily="ProximaNova"
                      fontSize="20px"
                      fontWeight="800"
                      color="rgba(149, 151, 171, 1)"
                      mx="10px"
                      >
                          FRX102- introductions ti trade  <br />
                          overview
                      </Text>
                  </Box>
                  
            </Stack>

          </VStack>
          {/* mobile-version */}
          <VStack
            w="100%"
            pb="40px"
            borderRadius="26px"
            bg={"rgba(255, 255, 255, 1)"}
            h="100%"
            className="mobile-version"
          >
            {/* Top Bar */}
            <Stack
              justifyContent={"flex-start"}
              alignItems={"center"}
              flexDir="row"
              w="100%"
              p={"15px 25px"}
              mt="40px"
              flexWrap="wrap"
              flexDirection={"column"}
            >
              <Image src={Img.favorite} width="13px" h="25px" />
              <Text
                fontFamily="ProximaNova"
                fontSize="20px"
                fontWeight="800"
                color="rgba(41, 45, 50, 1)"

              >
                Favorite Sessions
              </Text>
              <Box
                borderBottom="1px solid rgba(236, 236, 236, 1)"
                w="100%"
                py="10px"
              ></Box>
            </Stack>
            <Stack p={"15px 25px"} w="100%">
                  <Box bg="rgba(255, 255, 255, 1)" boxShadow= "0px 10px 10px 0px rgba(96, 31, 235, 0.06)" padding={'15px 24px'} w="100%" display="flex" justifyContent="flex-start" alignItems='center' borderRadius="15px">
                      <Image src={Img.play} w="21.67px" h="26px"/>
                      <Text           
                      fontFamily="ProximaNova"
                      fontSize="20px"
                      fontWeight="800"
                      color="rgba(149, 151, 171, 1)"
                      mx="10px"
                      >
                          FRX102- introductions ti trade  <br />
                          overview
                      </Text>
                  </Box>
                  <Box bg="rgba(255, 255, 255, 1)" boxShadow= "0px 10px 10px 0px rgba(96, 31, 235, 0.06)" padding={'15px 24px'} w="100%" display="flex" justifyContent="flex-start" alignItems='center' borderRadius="15px">
                      <Image src={Img.play} w="21.67px" h="26px"/>
                      <Text           
                      fontFamily="ProximaNova"
                      fontSize="20px"
                      fontWeight="800"
                      color="rgba(149, 151, 171, 1)"
                      mx="10px"
                      >
                          FRX102- introductions ti trade  <br />
                          overview
                      </Text>
                  </Box>
                  <Box bg="rgba(255, 255, 255, 1)" boxShadow= "0px 10px 10px 0px rgba(96, 31, 235, 0.06)" padding={'15px 24px'} w="100%" display="flex" justifyContent="flex-start" alignItems='center' borderRadius="15px">
                      <Image src={Img.play} w="21.67px" h="26px"/>
                      <Text           
                      fontFamily="ProximaNova"
                      fontSize="20px"
                      fontWeight="800"
                      color="rgba(149, 151, 171, 1)"
                      mx="10px"
                      >
                          FRX102- introductions ti trade  <br />
                          overview
                      </Text>
                  </Box>
                  
            </Stack>

          </VStack>
      </div>
  );
};

export default FavoriteSessions;
